import React from "react";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const euros = (amount) => `${Number(amount).toLocaleString("fr-FR")} € HT`;

export const MGSupportPanel = ({ model, formData, onLoyaltyChange, onTierChange }) => {
  const plan = model.mg_support;
  const category = formData.company_type === "NON" ? "B2C" : formData.company_type;
  const isB2C = category === "B2C";
  const eligible = plan.loyalty_categories.includes(category);
  const hasTiers = category === "B2B01" && Object.keys(plan.b2b01_tiers || {}).length > 0;
  const tier = hasTiers ? plan.b2b01_tiers[formData.mg_b2b01_tier] : null;
  const support = hasTiers ? tier?.support_ht : isB2C ? plan.b2c_support_ht : plan.b2b_supports_ht[category];
  const discountRate = hasTiers ? tier?.discount_rate : plan.b2b_discount_rates[category];
  return (
    <section data-testid="mg-support-panel" className="mt-4 border-t border-red-200 pt-4 space-y-3">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h3 data-testid="mg-support-title" className="text-sm font-semibold">Support MG · {category}</h3>
        <span data-testid="mg-support-period" className="text-xs text-muted-foreground">{plan.period}</span>
      </div>
      {hasTiers && (
        <div className="space-y-2">
          <label id="mg-tier-label" data-testid="mg-tier-label" className="text-sm font-medium">Palier B2B01</label>
          <Select value={formData.mg_b2b01_tier || ""} onValueChange={onTierChange}>
            <SelectTrigger data-testid="mg-b2b01-tier-select" aria-labelledby="mg-tier-label"><SelectValue placeholder="Sélectionner un palier" /></SelectTrigger>
            <SelectContent>{Object.keys(plan.b2b01_tiers).map((key) => (
              <SelectItem key={key} value={key} data-testid={`mg-b2b01-tier-option-${key}`}>Palier {key}</SelectItem>
            ))}</SelectContent>
          </Select>
        </div>
      )}
      <p data-testid="mg-support-rule" className="text-sm">
        {support === undefined ? "Support selon le palier sélectionné." : <>
        Marge de base {Number(model.base_margin_rate * 100).toLocaleString("fr-FR")} % + support {isB2C && plan.b2c_discount_linked ? "selon remise client, plafonné pour cette finition à " : "de "}
        <strong>{euros(support)}</strong>.</>}
      </p>
      <p data-testid="mg-reference-discount" className="text-xs text-muted-foreground">
        {isB2C ? `Remise de référence : ${Number(plan.b2c_reference_discount_ttc).toLocaleString("fr-FR")} € TTC · VN et VD éligibles.` :
          `${discountRate !== undefined ? `Remise de référence : ${Number(discountRate * 100).toLocaleString("fr-FR")} % · ` : ""}VN uniquement, hors VD.`}
      </p>
      {!isB2C && plan.quality_prime_rate > 0 && (
        <p data-testid="mg-quality-prime-rule" className="text-sm">Prime qualité garantie : {Number(plan.quality_prime_rate * 100).toLocaleString("fr-FR")} % du prix HT, comptée une seule fois.</p>
      )}
      <div className="flex items-center justify-between gap-3 border-t pt-3">
        <label htmlFor="mg-loyalty" data-testid="mg-loyalty-label" className="text-sm">
          Prime fidélité <span className="text-muted-foreground">{eligible ? euros(model.prime_fidelite || 0) : "— non éligible en B2B03"}</span>
        </label>
        <Switch id="mg-loyalty" data-testid="mg-loyalty-switch" disabled={!eligible || !model.prime_fidelite}
          checked={eligible && formData.has_prime_fidelite} onCheckedChange={onLoyaltyChange} />
      </div>
    </section>
  );
};